var map = {
	"./about-header-1450x291.webp": 68359,
	"./app-assets/global/computer.jpg": 49387,
	"./app-assets/global/privacyPolicy": 70013,
	"./app-assets/global/privacyPolicy.vue": 70013,
	"./app-assets/global/refundReturnPolicy": 32381,
	"./app-assets/global/refundReturnPolicy.vue": 32381,
	"./app-assets/global/termsAndConditions": 35161,
	"./app-assets/global/termsAndConditions.vue": 35161,
	"./app-assets/teacher/teacher-stats-img.jpg": 22625,
	"./avatar-v2-square.svg": 63002,
	"./computer.jpg": 34007,
	"./fonts/Arial.ttf": 88143,
	"./fonts/Delight.ttf": 9725,
	"./fonts/TeachersPet.ttf": 46958,
	"./icons8-tiktok-24.png": 2444,
	"./juffrou-anri-animate-head.webp": 15606,
	"./juffrou-anri-animate.gif": 82515,
	"./logo-full.svg": 9911,
	"./logo-square.png": 79037,
	"./logo-v2-long.svg": 40963,
	"./logo-v2-long_no-space.svg": 47814,
	"./logo-v2-square.svg": 13000,
	"./logo-v2.svg": 8360,
	"./logo.png": 33153,
	"./logo.svg": 63935,
	"./my-story.webp": 59683,
	"./team/2025-01-31/Juff-Anri-2.webp": 95675,
	"./team/2025-01-31/Juff-Anri-2nd group-1.webp": 53284,
	"./team/2025-01-31/Juff-Anri-2nd group-2.webp": 87809,
	"./team/2025-01-31/Juff-Anri-2nd group-3.webp": 18054,
	"./team/2025-01-31/Juff-Anri-3.webp": 52856,
	"./team/2025-01-31/Juff-Anri-4.webp": 8401,
	"./team/2025-08-19/Charlise Olckers.webp": 88631,
	"./team/2025-08-19/DSCF2940.webp": 72582,
	"./team/2025-08-19/Ina Dekker.webp": 74015,
	"./team/2025-08-19/Natasha Coetzee.webp": 95388,
	"./team/2025-08-19/about-team-1920x882.webp": 82335,
	"./team/2025-08-19/ret anri1-cropped.webp": 44981,
	"./team/2025-08-19/ret anri1.webp": 30207,
	"./team/2025-08-19/ret anri2-cropped.webp": 31364,
	"./team/2025-08-19/ret anri2.webp": 41566,
	"./team/2026-10-19/Bianca Koorts.webp": 95251,
	"./team/2026-10-19/Elske Jonker.webp": 52472,
	"./team/2026-10-19/Jané Bezuidenhout.webp": 91845,
	"./team/2026-10-19/Marijke Hamann.webp": 45061,
	"./team/2026-10-19/Nicole Meyer.webp": 77207,
	"./team/2026-10-19/Venita Joubert.webp": 2567,
	"./user-profile-img-blank.png": 91286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;